import { render, staticRenderFns } from "./SiteNavSubMenuItem.vue?vue&type=template&id=34425eeb&scoped=true&lang=pug&"
import script from "./SiteNavSubMenuItem.vue?vue&type=script&lang=js&"
export * from "./SiteNavSubMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34425eeb",
  null
  
)

export default component.exports